import type { VideoEvidence } from "../ChatEventTypes";

const FULL_VIDEO_EPSILON_SEC = 0.05;

/** True when playback spans (effectively) the entire source video. */
export function isFullVideoEvidence(clip: VideoEvidence): boolean {
	const videoDuration = Math.max(0, clip.video_duration ?? 0);
	if (videoDuration <= 0) {
		return true;
	}

	const clipStart = clip.source_start_time ?? clip.start_time ?? 0;
	const clipDuration = Math.max(
		0,
		clip.clip_duration ??
			(clip.end_time != null && clip.start_time != null
				? clip.end_time - clip.start_time
				: videoDuration),
	);

	return (
		clipStart <= FULL_VIDEO_EPSILON_SEC &&
		clipDuration >= videoDuration - FULL_VIDEO_EPSILON_SEC
	);
}
